var _g, _path, _circle, _path2, _g2, _g3, _path3, _g4, _path4, _g5, _path5, _g6, _path6, _g7, _path7, _g8, _g9, _g10, _g11, _g12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 704,
  height: 670,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__a)",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("circle", {
  cx: 335,
  cy: 334.999,
  r: 135,
  fill: "url(#what_svg__b)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.02,
  stroke: "url(#what_svg__c)",
  strokeWidth: 2,
  d: "M335.5 132C447.89 132 539 223.11 539 335.5c0 112.389-91.11 203.499-203.5 203.5C223.11 539 132 447.889 132 335.5 132 223.11 223.11 132 335.5 132Z",
  opacity: 0.3
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 335,
  cy: 335,
  r: 150,
  fill: "#fff",
  fillOpacity: 0.02,
  stroke: "url(#what_svg__d)",
  strokeWidth: 2,
  opacity: 0.3,
  transform: "rotate(-90 335 335)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.02,
  stroke: "url(#what_svg__e)",
  strokeWidth: 2,
  d: "M335.5 240c52.738 0 95.5 42.975 95.5 96s-42.762 96-95.5 96-95.5-42.976-95.5-96 42.762-96 95.5-96Z",
  opacity: 0.3
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__f)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.5,
  cy: 14,
  fill: "url(#what_svg__g)",
  rx: 10.5,
  ry: 14,
  transform: "matrix(1 0 0 -1 327 231.883)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__h)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.5,
  cy: 14,
  fill: "#000",
  rx: 10.5,
  ry: 14,
  transform: "matrix(1 0 0 -1 327 290.883)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__i)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.5,
  cy: 14,
  fill: "#000",
  rx: 10.5,
  ry: 14,
  transform: "matrix(1 0 0 -1 327 349.883)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__j)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.5,
  cy: 14,
  fill: "#000",
  rx: 10.5,
  ry: 14,
  transform: "matrix(1 0 0 -1 327 408.883)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__k)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.5,
  cy: 14,
  fill: "#000",
  rx: 10.5,
  ry: 14,
  transform: "matrix(1 0 0 -1 327 467.883)"
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__l)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__m)",
  d: "M349.654 237.883h-5.308v-20.988h-7.33v-4.377h19.986v4.377h-7.348z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__n)",
  d: "M366.927 234.343c2.507 0 4.466-1.726 4.466-4.001v-1.378l-4.3.266c-2.142.149-3.354 1.096-3.354 2.59 0 1.527 1.262 2.523 3.188 2.523m-.996 2.839c-3.42 0-5.811-2.125-5.811-5.263 0-3.054 2.341-4.93 6.491-5.163l4.782-.282v-1.345c0-1.942-1.312-3.104-3.503-3.104-2.076 0-3.37.996-3.686 2.557h-3.387c.2-3.155 2.889-5.479 7.205-5.479 4.234 0 6.94 2.241 6.94 5.744v12.036h-3.437v-2.872h-.083c-1.012 1.943-3.22 3.171-5.511 3.171m12.633-.299v-17.465h3.586v17.465zm1.793-20.021c-1.145 0-2.075-.913-2.075-2.042 0-1.146.93-2.059 2.075-2.059 1.163 0 2.092.913 2.092 2.059 0 1.129-.929 2.042-2.092 2.042m5.595 20.021v-23.956h3.586v23.956zm14.776.332c-4.998 0-8.285-3.436-8.285-9.064 0-5.611 3.304-9.048 8.285-9.048s8.284 3.437 8.284 9.048c0 5.628-3.287 9.064-8.284 9.064m0-2.955c2.822 0 4.631-2.224 4.631-6.109 0-3.868-1.826-6.093-4.631-6.093s-4.632 2.225-4.632 6.093c0 3.885 1.826 6.109 4.632 6.109m11.056 2.623v-17.465h3.42v2.972h.083c.581-2.042 2.142-3.254 4.2-3.254.515 0 .963.083 1.229.133v3.337c-.282-.116-.913-.199-1.611-.199-2.307 0-3.735 1.544-3.735 4.017v10.459zm17.697-14.891c-2.506 0-4.266 1.909-4.449 4.549h8.733c-.083-2.673-1.777-4.549-4.284-4.549m4.267 9.761h3.403c-.498 3.188-3.519 5.462-7.52 5.462-5.13 0-8.235-3.469-8.235-8.981 0-5.479 3.155-9.131 8.085-9.131 4.848 0 7.87 3.42 7.87 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m12.949 5.429c-4.416 0-7.338-3.519-7.338-9.031s2.922-9.015 7.305-9.015c2.507 0 4.499 1.262 5.479 3.188h.066v-9.397h3.603v23.956h-3.487v-2.971h-.066c-1.03 1.992-3.022 3.27-5.562 3.27m.947-15.024c-2.839 0-4.616 2.324-4.616 5.993 0 3.685 1.777 5.993 4.616 5.993 2.755 0 4.598-2.341 4.598-5.993 0-3.619-1.843-5.993-4.598-5.993m28.853 14.725h-3.719v-20.752h-7.338v-3.204h18.378v3.204h-7.321zm10.061 0v-23.956h3.552v9.413h.083c.963-2.042 2.872-3.22 5.529-3.22 3.835 0 6.126 2.556 6.126 6.507v11.256h-3.603v-10.558c0-2.574-1.295-4.117-3.818-4.117-2.656 0-4.283 1.826-4.283 4.582v10.093zm26.064-14.891c-2.507 0-4.267 1.909-4.449 4.549h8.732c-.083-2.673-1.776-4.549-4.283-4.549m4.267 9.761h3.403c-.498 3.188-3.52 5.462-7.521 5.462-5.129 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.848 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.035-2.557m6.391 5.13v-17.465h3.42v2.939h.083c.78-1.942 2.607-3.237 4.964-3.237 2.424 0 4.184 1.245 4.881 3.42h.083c.896-2.125 2.955-3.42 5.445-3.42 3.453 0 5.711 2.291 5.711 5.76v12.003h-3.602v-11.139c0-2.258-1.212-3.553-3.337-3.553s-3.603 1.577-3.603 3.785v10.907h-3.519v-11.405c0-2.009-1.279-3.287-3.304-3.287-2.125 0-3.636 1.66-3.636 3.901v10.791zm35.362-14.891c-2.507 0-4.267 1.909-4.45 4.549h8.733c-.083-2.673-1.777-4.549-4.283-4.549m4.266 9.761h3.404c-.499 3.188-3.52 5.462-7.521 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.847 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m6.076-7.387c0-3.121 2.756-5.263 6.84-5.263 3.885 0 6.608 2.175 6.724 5.279h-3.37c-.166-1.577-1.445-2.556-3.453-2.556-1.943 0-3.238.946-3.238 2.324 0 1.079.864 1.809 2.673 2.258l2.939.68c3.519.847 4.847 2.175 4.847 4.748 0 3.188-2.971 5.379-7.255 5.379-4.133 0-6.873-2.141-7.155-5.345h3.553c.282 1.676 1.577 2.606 3.768 2.606 2.159 0 3.487-.896 3.487-2.308 0-1.112-.664-1.726-2.49-2.191l-3.122-.764c-3.154-.763-4.748-2.407-4.748-4.847",
  opacity: 0.8
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__o)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__p)",
  d: "M343.674 267.518v15.873c0 3.252 1.916 5.379 5.326 5.379 3.393 0 5.309-2.127 5.309-5.379v-15.873h5.308v16.4c0 5.59-4.131 9.405-10.617 9.405-6.504 0-10.635-3.815-10.635-9.405v-16.4z"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__q)",
  d: "M364.977 291.883v-17.465h3.419v2.922h.083c.947-1.992 2.806-3.22 5.496-3.22 3.851 0 6.059 2.457 6.059 6.458v11.305h-3.602v-10.608c0-2.623-1.229-4.067-3.719-4.067-2.524 0-4.151 1.792-4.151 4.499v10.176zm18.643 0v-17.465h3.586v17.465zm1.793-20.021c-1.145 0-2.075-.913-2.075-2.042 0-1.146.93-2.059 2.075-2.059 1.162 0 2.092.913 2.092 2.059 0 1.129-.93 2.042-2.092 2.042m6.508 20.021v-14.626h-2.407v-2.805h2.407v-1.71c0-3.387 1.594-4.981 5.146-4.981.731 0 1.544.083 2.009.166v2.656a7.6 7.6 0 0 0-1.311-.099c-1.561 0-2.291.78-2.291 2.324v1.644h3.536v2.805h-3.487v14.626zm10.027 0v-17.465h3.586v17.465zm1.793-20.021c-1.145 0-2.075-.913-2.075-2.042 0-1.146.93-2.059 2.075-2.059 1.162 0 2.092.913 2.092 2.059 0 1.129-.93 2.042-2.092 2.042m12.767 5.13c-2.507 0-4.267 1.909-4.449 4.549h8.732c-.083-2.673-1.776-4.549-4.283-4.549m4.266 9.761h3.404c-.498 3.188-3.52 5.462-7.521 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.847 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m12.95 5.429c-4.416 0-7.338-3.519-7.338-9.031s2.922-9.015 7.304-9.015c2.507 0 4.499 1.262 5.479 3.188h.066v-9.397h3.603v23.956h-3.486v-2.971h-.067c-1.029 1.992-3.021 3.27-5.561 3.27m.946-15.024c-2.839 0-4.615 2.324-4.615 5.993 0 3.685 1.776 5.993 4.615 5.993 2.756 0 4.599-2.341 4.599-5.993 0-3.619-1.843-5.993-4.599-5.993m22.91 14.725h-3.719v-23.956h3.719zm3.984 0v-17.465h3.42v2.922h.083c.947-1.992 2.806-3.22 5.495-3.22 3.852 0 6.06 2.457 6.06 6.458v11.305h-3.602v-10.608c0-2.623-1.229-4.067-3.719-4.067-2.524 0-4.151 1.792-4.151 4.499v10.176zm19.574-21.598h3.602v4.133h3.321v2.839h-3.321v9.629c0 1.511.664 2.192 2.125 2.192.365 0 .947-.034 1.179-.083v2.838c-.398.1-1.195.167-1.992.167-3.536 0-4.914-1.345-4.914-4.715v-10.028h-2.54v-2.839h2.54zm16.751 6.707c-2.507 0-4.267 1.909-4.45 4.549h8.733c-.083-2.673-1.776-4.549-4.283-4.549m4.266 9.761h3.404c-.498 3.188-3.52 5.462-7.521 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.847 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m13.829 2.225c2.806 0 4.649-2.274 4.649-5.877 0-3.586-1.843-5.943-4.649-5.943-2.755 0-4.548 2.307-4.548 5.943 0 3.652 1.793 5.877 4.548 5.877m.034 9.48c-4.118 0-7.172-2.192-7.621-5.213H512c.515 1.461 2.108 2.423 4.15 2.423 2.806 0 4.466-1.593 4.466-3.984v-2.872h-.066c-.98 1.893-3.038 3.138-5.529 3.138-4.382 0-7.254-3.42-7.254-8.866 0-5.495 2.855-8.948 7.337-8.948 2.474 0 4.5 1.245 5.562 3.271h.066v-2.989h3.487v17.15c0 4.167-3.221 6.89-8.201 6.89m11.753-6.575v-17.465h3.42v2.972h.083c.581-2.042 2.142-3.254 4.201-3.254.514 0 .963.083 1.228.133v3.337c-.282-.116-.913-.199-1.61-.199-2.308 0-3.736 1.544-3.736 4.017v10.459zm16.901-2.54c2.507 0 4.466-1.726 4.466-4.001v-1.378l-4.3.266c-2.142.149-3.354 1.096-3.354 2.59 0 1.527 1.262 2.523 3.188 2.523m-.996 2.839c-3.42 0-5.811-2.125-5.811-5.263 0-3.054 2.341-4.93 6.491-5.163l4.782-.282v-1.345c0-1.942-1.312-3.104-3.503-3.104-2.075 0-3.37.996-3.686 2.557h-3.387c.2-3.155 2.889-5.479 7.206-5.479 4.233 0 6.939 2.241 6.939 5.744v12.036h-3.436v-2.872h-.083c-1.013 1.943-3.221 3.171-5.512 3.171m13.563-21.897h3.603v4.133h3.32v2.839h-3.32v9.629c0 1.511.664 2.192 2.125 2.192.365 0 .946-.034 1.179-.083v2.838c-.399.1-1.196.167-1.993.167-3.536 0-4.914-1.345-4.914-4.715v-10.028h-2.54v-2.839h2.54zm9.994 21.598v-17.465h3.586v17.465zm1.793-20.021c-1.145 0-2.075-.913-2.075-2.042 0-1.146.93-2.059 2.075-2.059 1.162 0 2.092.913 2.092 2.059 0 1.129-.93 2.042-2.092 2.042m12.966 20.353c-4.997 0-8.284-3.436-8.284-9.064 0-5.611 3.304-9.048 8.284-9.048s8.284 3.437 8.284 9.048c0 5.628-3.287 9.064-8.284 9.064m0-2.955c2.822 0 4.632-2.224 4.632-6.109 0-3.868-1.826-6.093-4.632-6.093s-4.632 2.225-4.632 6.093c0 3.885 1.827 6.109 4.632 6.109m11.057 2.623v-17.465h3.42v2.922h.083c.946-1.992 2.805-3.22 5.495-3.22 3.851 0 6.059 2.457 6.059 6.458v11.305h-3.602v-10.608c0-2.623-1.229-4.067-3.719-4.067-2.523 0-4.15 1.792-4.15 4.499v10.176z",
  opacity: 0.8
})), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__r)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__s)",
  d: "M343.887 326.667v8.085h4.57c2.672 0 4.236-1.529 4.236-4.043 0-2.46-1.652-4.042-4.289-4.042zm0 11.935v9.281h-5.309v-25.365h10.389c5.836 0 9.176 3.076 9.176 8.086 0 3.252-1.688 6.064-4.606 7.207l5.344 10.072h-6.012l-4.728-9.281z"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__t)",
  d: "M369.335 344.343c2.507 0 4.466-1.726 4.466-4.001v-1.378l-4.3.266c-2.142.149-3.354 1.096-3.354 2.59 0 1.527 1.262 2.523 3.188 2.523m-.996 2.839c-3.42 0-5.811-2.125-5.811-5.263 0-3.054 2.341-4.93 6.492-5.163l4.781-.282v-1.345c0-1.942-1.312-3.104-3.503-3.104-2.075 0-3.37.996-3.686 2.557h-3.386c.199-3.155 2.888-5.479 7.205-5.479 4.233 0 6.939 2.241 6.939 5.744v12.036h-3.436v-2.872h-.083c-1.013 1.943-3.221 3.171-5.512 3.171m21.615-18.046c4.433 0 7.355 3.487 7.355 9.015s-2.906 9.031-7.288 9.031c-2.507 0-4.5-1.228-5.496-3.171h-.083v8.65h-3.586v-23.243h3.47v3.005h.067c1.029-2.008 3.038-3.287 5.561-3.287m-.946 15.008c2.839 0 4.615-2.324 4.615-5.993 0-3.652-1.776-5.993-4.615-5.993-2.739 0-4.582 2.39-4.582 5.993 0 3.636 1.826 5.993 4.582 5.993m11.189 2.739v-17.465h3.586v17.465zm1.793-20.021c-1.145 0-2.075-.913-2.075-2.042 0-1.146.93-2.059 2.075-2.059 1.162 0 2.092.913 2.092 2.059 0 1.129-.93 2.042-2.092 2.042m12.02 20.32c-4.416 0-7.338-3.519-7.338-9.031s2.922-9.015 7.305-9.015c2.506 0 4.499 1.262 5.478 3.188h.066v-9.397h3.603v23.956h-3.486v-2.971h-.067c-1.029 1.992-3.021 3.27-5.561 3.27m.946-15.024c-2.839 0-4.615 2.324-4.615 5.993 0 3.685 1.776 5.993 4.615 5.993 2.756 0 4.599-2.341 4.599-5.993 0-3.619-1.843-5.993-4.599-5.993m19.191-9.231h8.982c4.648 0 7.886 3.204 7.886 7.869 0 4.682-3.304 7.903-8.002 7.903h-5.147v8.184h-3.719zm3.719 3.138v9.513h4.267c3.237 0 5.08-1.744 5.08-4.765s-1.843-4.748-5.064-4.748zm20.686 18.278c2.507 0 4.466-1.726 4.466-4.001v-1.378l-4.3.266c-2.142.149-3.354 1.096-3.354 2.59 0 1.527 1.262 2.523 3.188 2.523m-.996 2.839c-3.42 0-5.811-2.125-5.811-5.263 0-3.054 2.341-4.93 6.491-5.163l4.782-.282v-1.345c0-1.942-1.312-3.104-3.503-3.104-2.076 0-3.37.996-3.686 2.557h-3.387c.2-3.155 2.889-5.479 7.205-5.479 4.234 0 6.94 2.241 6.94 5.744v12.036h-3.437v-2.872h-.083c-1.012 1.943-3.22 3.171-5.511 3.171m19.955-3.204c2.805 0 4.648-2.274 4.648-5.877 0-3.586-1.843-5.943-4.648-5.943-2.756 0-4.549 2.307-4.549 5.943 0 3.652 1.793 5.877 4.549 5.877m.033 9.48c-4.117 0-7.172-2.192-7.62-5.213h3.602c.515 1.461 2.109 2.423 4.151 2.423 2.805 0 4.466-1.593 4.466-3.984v-2.872h-.067c-.979 1.893-3.038 3.138-5.528 3.138-4.383 0-7.255-3.42-7.255-8.866 0-5.495 2.855-8.948 7.338-8.948 2.473 0 4.499 1.245 5.561 3.271h.067v-2.989h3.486v17.15c0 4.167-3.221 6.89-8.201 6.89m19.059-21.466c-2.507 0-4.267 1.909-4.45 4.549h8.733c-.083-2.673-1.777-4.549-4.283-4.549m4.266 9.761h3.403c-.498 3.188-3.519 5.462-7.52 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.847 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m12.667-1.544h3.669c.266 2.374 2.573 3.935 5.728 3.935 3.021 0 5.196-1.561 5.196-3.702 0-1.859-1.312-2.972-4.416-3.735l-3.105-.748c-4.399-1.062-6.441-3.121-6.441-6.458 0-4.133 3.603-6.972 8.716-6.972 5.063 0 8.533 2.839 8.649 6.972h-3.619c-.216-2.39-2.191-3.834-5.08-3.834s-4.864 1.46-4.864 3.585c0 1.694 1.261 2.69 4.349 3.454l2.64.647c4.914 1.162 6.956 3.138 6.956 6.641 0 4.482-3.569 7.288-9.247 7.288-5.313 0-8.898-2.74-9.131-7.073m30.381-11.073c4.433 0 7.354 3.487 7.354 9.015s-2.905 9.031-7.288 9.031c-2.506 0-4.499-1.228-5.495-3.171h-.083v8.65h-3.586v-23.243h3.47v3.005h.066c1.03-2.008 3.039-3.287 5.562-3.287m-.946 15.008c2.839 0 4.615-2.324 4.615-5.993 0-3.652-1.776-5.993-4.615-5.993-2.74 0-4.582 2.39-4.582 5.993 0 3.636 1.826 5.993 4.582 5.993m18.378-12.152c-2.507 0-4.267 1.909-4.45 4.549h8.733c-.083-2.673-1.777-4.549-4.283-4.549m4.266 9.761h3.404c-.498 3.188-3.52 5.462-7.521 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.847 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m13.697-9.761c-2.507 0-4.267 1.909-4.45 4.549h8.733c-.083-2.673-1.777-4.549-4.283-4.549m4.266 9.761h3.403c-.498 3.188-3.519 5.462-7.52 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.847 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m12.949 5.429c-4.416 0-7.338-3.519-7.338-9.031s2.922-9.015 7.305-9.015c2.507 0 4.499 1.262 5.479 3.188h.066v-9.397h3.603v23.956h-3.487v-2.971h-.066c-1.029 1.992-3.022 3.27-5.562 3.27m.947-15.024c-2.839 0-4.616 2.324-4.616 5.993 0 3.685 1.777 5.993 4.616 5.993 2.755 0 4.598-2.341 4.598-5.993 0-3.619-1.843-5.993-4.598-5.993",
  opacity: 0.8
})), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__u)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__v)",
  d: "M349.828 402.883h-11.232v-25.365h11.039c4.763 0 7.752 2.443 7.752 6.328 0 2.778-2.075 5.098-4.764 5.502v.141c3.445.263 5.977 2.777 5.977 6.135 0 4.464-3.358 7.259-8.772 7.259m-5.924-21.41v6.592h3.815c2.83 0 4.447-1.248 4.447-3.393 0-2.039-1.424-3.199-3.902-3.199zm0 17.455h4.571c3.058 0 4.711-1.301 4.711-3.726 0-2.373-1.706-3.639-4.834-3.639h-4.448z"
}))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__w)",
  d: "M370.153 386.992c-2.507 0-4.266 1.909-4.449 4.549h8.733c-.083-2.673-1.777-4.549-4.284-4.549m4.267 9.761h3.403c-.498 3.188-3.519 5.462-7.52 5.462-5.13 0-8.235-3.469-8.235-8.981 0-5.479 3.155-9.131 8.085-9.131 4.848 0 7.869 3.42 7.869 8.716v1.228h-12.334v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.552-1.029 4.034-2.557m6.076-7.387c0-3.121 2.756-5.263 6.84-5.263 3.885 0 6.607 2.175 6.724 5.279h-3.371c-.166-1.577-1.444-2.556-3.453-2.556-1.942 0-3.237.946-3.237 2.324 0 1.079.863 1.809 2.673 2.258l2.938.68c3.52.847 4.848 2.175 4.848 4.748 0 3.188-2.972 5.379-7.255 5.379-4.134 0-6.873-2.141-7.155-5.345h3.553c.282 1.676 1.577 2.606 3.768 2.606 2.158 0 3.486-.896 3.486-2.308 0-1.112-.664-1.726-2.49-2.191l-3.121-.764c-3.154-.763-4.748-2.407-4.748-4.847m25.849-5.23c4.432 0 7.354 3.487 7.354 9.015s-2.905 9.031-7.288 9.031c-2.507 0-4.499-1.228-5.495-3.171h-.083v8.65h-3.586v-23.243h3.47v3.005h.066c1.029-2.008 3.038-3.287 5.562-3.287m-.947 15.008c2.839 0 4.616-2.324 4.616-5.993 0-3.652-1.777-5.993-4.616-5.993-2.739 0-4.582 2.39-4.582 5.993 0 3.636 1.827 5.993 4.582 5.993m18.578 3.071c-4.997 0-8.285-3.436-8.285-9.064 0-5.611 3.304-9.048 8.285-9.048s8.284 3.437 8.284 9.048c0 5.628-3.287 9.064-8.284 9.064m0-2.955c2.822 0 4.631-2.224 4.631-6.109 0-3.868-1.826-6.093-4.631-6.093s-4.632 2.225-4.632 6.093c0 3.885 1.826 6.109 4.632 6.109m14.808-7.354 7.056-7.488h4.217l-7.239 7.521 7.521 9.944h-4.167l-5.927-7.753-1.494 1.478v6.275h-3.586v-23.956h3.586v13.979zm19.889-4.914c-2.507 0-4.267 1.909-4.449 4.549h8.732c-.083-2.673-1.776-4.549-4.283-4.549m4.266 9.761h3.404c-.498 3.188-3.52 5.462-7.521 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.848 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m23.84 5.529c-6.723 0-10.973-4.748-10.973-12.385 0-7.587 4.283-12.368 10.973-12.368 5.429 0 9.53 3.337 10.16 8.334h-3.685c-.664-3.071-3.221-5.08-6.475-5.08-4.349 0-7.172 3.569-7.172 9.114 0 5.595 2.789 9.131 7.189 9.131 3.337 0 5.711-1.71 6.458-4.599h3.702c-.913 4.947-4.665 7.853-10.177 7.853m28.074-17.864v17.465h-3.437v-2.955h-.083c-.963 2.092-2.739 3.271-5.412 3.271-3.802 0-6.126-2.474-6.126-6.475v-11.306h3.586v10.609c0 2.656 1.262 4.084 3.735 4.084 2.59 0 4.151-1.793 4.151-4.516v-10.177zm3.237 4.948c0-3.121 2.756-5.263 6.84-5.263 3.884 0 6.607 2.175 6.723 5.279h-3.37c-.166-1.577-1.444-2.556-3.453-2.556-1.942 0-3.237.946-3.237 2.324 0 1.079.863 1.809 2.673 2.258l2.938.68c3.52.847 4.848 2.175 4.848 4.748 0 3.188-2.972 5.379-7.255 5.379-4.134 0-6.873-2.141-7.155-5.345h3.552c.283 1.676 1.577 2.606 3.769 2.606 2.158 0 3.486-.896 3.486-2.308 0-1.112-.664-1.726-2.49-2.191l-3.121-.764c-3.154-.763-4.748-2.407-4.748-4.847m17.797-9.081h3.602v4.133h3.321v2.839h-3.321v9.629c0 1.511.664 2.192 2.125 2.192.365 0 .947-.034 1.179-.083v2.838c-.398.1-1.195.167-1.992.167-3.536 0-4.914-1.345-4.914-4.715v-10.028h-2.54v-2.839h2.54zm16.95 21.93c-4.997 0-8.284-3.436-8.284-9.064 0-5.611 3.303-9.048 8.284-9.048 4.98 0 8.284 3.437 8.284 9.048 0 5.628-3.287 9.064-8.284 9.064m0-2.955c2.822 0 4.632-2.224 4.632-6.109 0-3.868-1.826-6.093-4.632-6.093s-4.632 2.225-4.632 6.093c0 3.885 1.826 6.109 4.632 6.109m11.057 2.623v-17.465h3.419v2.939h.083c.781-1.942 2.607-3.237 4.964-3.237 2.424 0 4.184 1.245 4.881 3.42h.083c.897-2.125 2.955-3.42 5.446-3.42 3.453 0 5.71 2.291 5.71 5.76v12.003h-3.602v-11.139c0-2.258-1.212-3.553-3.337-3.553s-3.603 1.577-3.603 3.785v10.907h-3.519v-11.405c0-2.009-1.278-3.287-3.304-3.287-2.125 0-3.636 1.66-3.636 3.901v10.791zm28.172 0v-17.465h3.586v17.465zm1.793-20.021c-1.145 0-2.075-.913-2.075-2.042 0-1.146.93-2.059 2.075-2.059 1.162 0 2.092.913 2.092 2.059 0 1.129-.93 2.042-2.092 2.042m5.097 20.021v-2.307l9.314-12.236v-.066h-9.248v-2.856h13.365v2.457l-9.081 12.086v.067h9.18v2.855zm22.844-2.54c2.507 0 4.466-1.726 4.466-4.001v-1.378l-4.3.266c-2.142.149-3.354 1.096-3.354 2.59 0 1.527 1.262 2.523 3.188 2.523m-.996 2.839c-3.42 0-5.811-2.125-5.811-5.263 0-3.054 2.341-4.93 6.491-5.163l4.782-.282v-1.345c0-1.942-1.312-3.104-3.503-3.104-2.075 0-3.37.996-3.686 2.557h-3.387c.2-3.155 2.889-5.479 7.206-5.479 4.233 0 6.939 2.241 6.939 5.744v12.036h-3.437v-2.872h-.083c-1.012 1.943-3.22 3.171-5.511 3.171m13.563-21.897h3.603v4.133h3.32v2.839h-3.32v9.629c0 1.511.664 2.192 2.125 2.192.365 0 .946-.034 1.178-.083v2.838c-.398.1-1.195.167-1.992.167-3.536 0-4.914-1.345-4.914-4.715v-10.028h-2.54v-2.839h2.54zm9.994 21.598v-17.465h3.586v17.465zm1.793-20.021c-1.145 0-2.075-.913-2.075-2.042 0-1.146.93-2.059 2.075-2.059 1.162 0 2.092.913 2.092 2.059 0 1.129-.93 2.042-2.092 2.042m12.966 20.353c-4.997 0-8.284-3.436-8.284-9.064 0-5.611 3.304-9.048 8.284-9.048s8.284 3.437 8.284 9.048c0 5.628-3.287 9.064-8.284 9.064m0-2.955c2.822 0 4.632-2.224 4.632-6.109 0-3.868-1.826-6.093-4.632-6.093s-4.632 2.225-4.632 6.093c0 3.885 1.826 6.109 4.632 6.109m11.057 2.623v-17.465h3.42v2.922h.083c.946-1.992 2.805-3.22 5.495-3.22 3.851 0 6.059 2.457 6.059 6.458v11.305h-3.602v-10.608c0-2.623-1.229-4.067-3.719-4.067-2.523 0-4.15 1.792-4.15 4.499v10.176z",
  opacity: 0.8
})), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__x)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__y)",
  d: "M350 432.079c7.506 0 12.234 5.045 12.234 13.13 0 8.069-4.728 13.114-12.234 13.114-7.523 0-12.234-5.045-12.234-13.114 0-8.085 4.711-13.13 12.234-13.13m0 4.429c-4.148 0-6.82 3.375-6.82 8.701 0 5.309 2.654 8.666 6.82 8.666 4.148 0 6.803-3.357 6.803-8.666 0-5.326-2.655-8.701-6.803-8.701"
}))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#what_svg__z)",
  d: "M376.172 439.136c4.432 0 7.354 3.487 7.354 9.015s-2.905 9.031-7.288 9.031c-2.507 0-4.499-1.228-5.495-3.171h-.083v8.65h-3.586v-23.243h3.47v3.005h.066c1.03-2.008 3.038-3.287 5.562-3.287m-.946 15.008c2.838 0 4.615-2.324 4.615-5.993 0-3.652-1.777-5.993-4.615-5.993-2.74 0-4.582 2.39-4.582 5.993 0 3.636 1.826 5.993 4.582 5.993m12.119-18.859h3.602v4.133h3.321v2.839h-3.321v9.629c0 1.511.664 2.192 2.125 2.192.366 0 .947-.034 1.179-.083v2.838c-.398.1-1.195.167-1.992.167-3.536 0-4.914-1.345-4.914-4.715v-10.028h-2.54v-2.839h2.54zm9.994 21.598v-17.465h3.586v17.465zm1.793-20.021c-1.146 0-2.075-.913-2.075-2.042 0-1.146.929-2.059 2.075-2.059 1.162 0 2.092.913 2.092 2.059 0 1.129-.93 2.042-2.092 2.042m5.462 20.021v-17.465h3.42v2.939h.083c.78-1.942 2.606-3.237 4.964-3.237 2.423 0 4.183 1.245 4.88 3.42h.083c.897-2.125 2.955-3.42 5.446-3.42 3.453 0 5.711 2.291 5.711 5.76v12.003h-3.603v-11.139c0-2.258-1.212-3.553-3.337-3.553s-3.602 1.577-3.602 3.785v10.907h-3.52v-11.405c0-2.009-1.278-3.287-3.304-3.287-2.125 0-3.635 1.66-3.635 3.901v10.791zm28.173 0v-17.465h3.586v17.465zm1.793-20.021c-1.146 0-2.076-.913-2.076-2.042 0-1.146.93-2.059 2.076-2.059 1.162 0 2.091.913 2.091 2.059 0 1.129-.929 2.042-2.091 2.042m5.096 20.021v-2.307l9.314-12.236v-.066h-9.247v-2.856h13.364v2.457l-9.081 12.086v.067h9.181v2.855zm23.475-14.891c-2.507 0-4.267 1.909-4.449 4.549h8.732c-.083-2.673-1.776-4.549-4.283-4.549m4.266 9.761h3.404c-.498 3.188-3.52 5.462-7.521 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.848 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m12.95 5.429c-4.416 0-7.338-3.519-7.338-9.031s2.922-9.015 7.304-9.015c2.507 0 4.499 1.262 5.479 3.188h.066v-9.397h3.603v23.956h-3.486v-2.971h-.067c-1.029 1.992-3.021 3.27-5.561 3.27m.946-15.024c-2.839 0-4.615 2.324-4.615 5.993 0 3.685 1.776 5.993 4.615 5.993 2.756 0 4.599-2.341 4.599-5.993 0-3.619-1.843-5.993-4.599-5.993m34.398 11.505v3.22h-15.207v-23.956h15.207v3.204h-11.488v7.006h10.874v3.088h-10.874v7.438zm9.928-3.205h-.083l-3.868 6.425h-3.885l5.761-8.716-5.678-8.749h4.018l3.818 6.326h.067l3.768-6.326h3.951l-5.727 8.633 5.661 8.832h-3.951zm19.225-11.322c4.432 0 7.354 3.487 7.354 9.015s-2.905 9.031-7.288 9.031c-2.507 0-4.499-1.228-5.495-3.171h-.083v8.65h-3.586v-23.243h3.47v3.005h.066c1.03-2.008 3.038-3.287 5.562-3.287m-.947 15.008c2.839 0 4.616-2.324 4.616-5.993 0-3.652-1.777-5.993-4.616-5.993-2.739 0-4.582 2.39-4.582 5.993 0 3.636 1.827 5.993 4.582 5.993m18.378-12.152c-2.506 0-4.266 1.909-4.449 4.549h8.733c-.083-2.673-1.777-4.549-4.284-4.549m4.267 9.761h3.403c-.498 3.188-3.519 5.462-7.52 5.462-5.13 0-8.235-3.469-8.235-8.981 0-5.479 3.155-9.131 8.085-9.131 4.848 0 7.87 3.42 7.87 8.716v1.228H557.81v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m6.392 5.13v-17.465h3.42v2.972h.083c.581-2.042 2.141-3.254 4.2-3.254.514 0 .963.083 1.228.133v3.337c-.282-.116-.913-.199-1.61-.199-2.308 0-3.735 1.544-3.735 4.017v10.459zm11.272 0v-17.465h3.586v17.465zm1.793-20.021c-1.145 0-2.075-.913-2.075-2.042 0-1.146.93-2.059 2.075-2.059 1.162 0 2.092.913 2.092 2.059 0 1.129-.93 2.042-2.092 2.042m12.767 5.13c-2.507 0-4.267 1.909-4.45 4.549h8.733c-.083-2.673-1.777-4.549-4.283-4.549m4.266 9.761h3.404c-.498 3.188-3.52 5.462-7.521 5.462-5.13 0-8.234-3.469-8.234-8.981 0-5.479 3.154-9.131 8.085-9.131 4.847 0 7.869 3.42 7.869 8.716v1.228H594.3v.216c0 3.038 1.826 5.047 4.698 5.047 2.042 0 3.553-1.029 4.034-2.557m6.392 5.13v-17.465h3.42v2.922h.083c.946-1.992 2.805-3.22 5.495-3.22 3.851 0 6.059 2.457 6.059 6.458v11.305h-3.602v-10.608c0-2.623-1.229-4.067-3.719-4.067-2.523 0-4.15 1.792-4.15 4.499v10.176zm33.518-11.455h-3.42c-.365-1.859-1.759-3.337-4.1-3.337-2.773 0-4.599 2.308-4.599 6.06 0 3.835 1.843 6.059 4.632 6.059 2.208 0 3.652-1.211 4.067-3.237h3.454c-.382 3.719-3.354 6.242-7.554 6.242-4.997 0-8.251-3.42-8.251-9.064 0-5.545 3.254-9.048 8.218-9.048 4.499 0 7.238 2.889 7.553 6.325m9.878-3.436c-2.507 0-4.266 1.909-4.449 4.549h8.733c-.083-2.673-1.777-4.549-4.284-4.549m4.267 9.761h3.403c-.498 3.188-3.519 5.462-7.52 5.462-5.13 0-8.235-3.469-8.235-8.981 0-5.479 3.155-9.131 8.085-9.131 4.848 0 7.869 3.42 7.869 8.716v1.228h-12.335v.216c0 3.038 1.827 5.047 4.699 5.047 2.042 0 3.552-1.029 4.034-2.557",
  opacity: 0.8
})), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__A)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  x: 234,
  y: 177,
  fill: "#fff",
  fillOpacity: 0.1,
  rx: 32
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 63,
  x: 234.5,
  y: 177.5,
  stroke: "#fff",
  strokeOpacity: 0.3,
  rx: 31.5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#what_svg__B)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M261.636 193h-8.727a2.91 2.91 0 0 0-2.909 2.909v8.727a2.91 2.91 0 0 0 2.909 2.909h8.727a2.913 2.913 0 0 0 2.91-2.909v-8.727a2.913 2.913 0 0 0-2.91-2.909M279.091 193h-8.727a2.91 2.91 0 0 0-2.909 2.909v8.727a2.91 2.91 0 0 0 2.909 2.909h8.727a2.913 2.913 0 0 0 2.91-2.909v-8.727a2.91 2.91 0 0 0-2.91-2.909M261.636 210.454h-8.727a2.91 2.91 0 0 0-2.909 2.909v8.727a2.913 2.913 0 0 0 2.909 2.91h8.727a2.913 2.913 0 0 0 2.91-2.91v-8.727a2.913 2.913 0 0 0-2.91-2.909M278.968 216.03h-2.545v-2.546a.85.85 0 0 0-.849-.848h-1.697a.847.847 0 0 0-.848.848v2.546h-2.546a.847.847 0 0 0-.848.848v1.697c0 .469.379.849.848.849h2.546v2.545c0 .469.379.849.848.849h1.697c.469 0 .849-.38.849-.849v-2.545h2.545c.469 0 .849-.38.849-.849v-1.697a.85.85 0 0 0-.849-.848"
})))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__C)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  x: 216,
  y: 303,
  fill: "#fff",
  fillOpacity: 0.1,
  rx: 32
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 63,
  x: 216.5,
  y: 303.5,
  stroke: "#fff",
  strokeOpacity: 0.3,
  rx: 31.5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#what_svg__D)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M237.689 343.058h1.892a8.44 8.44 0 0 1 1.599-4.077l-1.343-1.342a10.3 10.3 0 0 0-2.148 5.419M247.058 335.581v-1.892a10.3 10.3 0 0 0-5.933 2.576l1.333 1.333a8.44 8.44 0 0 1 4.6-2.017M254.874 336.265a10.3 10.3 0 0 0-5.933-2.576v1.892a8.44 8.44 0 0 1 4.6 2.017zM256.419 343.058h1.892a10.3 10.3 0 0 0-2.148-5.419l-1.343 1.342a8.4 8.4 0 0 1 1.599 4.077M248 344.941a.94.94 0 1 0 0-1.881.94.94 0 0 0 0 1.881"
}), /*#__PURE__*/React.createElement("path", {
  d: "M232 348.588a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V328h-32zm20.706-3.647h-2.044a2.83 2.83 0 0 1-2.662 1.882 2.827 2.827 0 0 1-2.824-2.823 2.827 2.827 0 0 1 2.824-2.824 2.83 2.83 0 0 1 2.662 1.882h2.044zM235.765 344c0-6.747 5.488-12.236 12.235-12.236s12.235 5.489 12.235 12.236v.941h-5.647V344a6.596 6.596 0 0 0-6.588-6.589 6.596 6.596 0 0 0-6.588 6.589v.941h-5.647z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M234 319a2 2 0 0 0-2 2v5.5h32V321a2 2 0 0 0-2-2zm1.945 3.753a.941.941 0 1 1-1.883 0 .941.941 0 0 1 1.883 0m2.059.941a.941.941 0 1 0 0-1.883.941.941 0 0 0 0 1.883m3.941-.941a.941.941 0 1 1-1.883 0 .941.941 0 0 1 1.883 0",
  clipRule: "evenodd"
})))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__E)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  x: 117,
  y: 223,
  fill: "#fff",
  fillOpacity: 0.1,
  rx: 32
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 63,
  x: 117.5,
  y: 223.5,
  stroke: "#fff",
  strokeOpacity: 0.3,
  rx: 31.5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#what_svg__F)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M146.188 271v-2.875a3.753 3.753 0 0 1-3.75-3.75 3.753 3.753 0 0 1 3.75-3.75v-2.813h-5.241l.446-1.252a1.877 1.877 0 0 0-1.768-2.498 1.877 1.877 0 0 0-1.768 2.498l.446 1.252H133c.465 7.006 6.182 12.722 13.188 13.188"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.625 252.187a3.754 3.754 0 0 1 3.75 3.75h2.813v-5.24l1.252.445c1.154.412 2.497-.52 2.498-1.767-.001-1.248-1.343-2.188-2.498-1.768l-1.252.446v-5.193c-7.006.465-12.723 6.071-13.188 13.077h2.875a3.754 3.754 0 0 1 3.75-3.75M161.14 257.812h-2.765a3.754 3.754 0 0 1-3.75 3.75 3.754 3.754 0 0 1-3.75-3.75h-2.812v5.241l-1.253-.446c-1.159-.417-2.498.52-2.497 1.768-.001 1.247 1.339 2.184 2.497 1.767l1.253-.445V271c7.005-.466 12.612-6.182 13.077-13.188"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.188 246.562v-3.75h-3.75c0-2.068-1.682-3.812-3.75-3.812s-3.75 1.744-3.75 3.812h-1.876v2.813a3.753 3.753 0 0 1 3.75 3.75 3.753 3.753 0 0 1-3.75 3.75v2.812h5.241l-.446 1.252a1.877 1.877 0 0 0 1.768 2.498 1.877 1.877 0 0 0 1.768-2.498l-.446-1.252h5.241v-1.875c2.068 0 3.812-1.682 3.812-3.75s-1.744-3.75-3.812-3.75"
})))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__G)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  x: 121,
  y: 393,
  fill: "#fff",
  fillOpacity: 0.1,
  rx: 32
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 63,
  x: 121.5,
  y: 393.5,
  stroke: "#fff",
  strokeOpacity: 0.3,
  rx: 31.5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#what_svg__H)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m168.184 421.518-2.333-.467a13.4 13.4 0 0 0-1.016-2.453l1.319-1.98a.94.94 0 0 0-.117-1.183l-3.535-3.535a.94.94 0 0 0-1.183-.117l-1.98 1.319a13.4 13.4 0 0 0-2.453-1.016l-.467-2.333a.936.936 0 0 0-.919-.753h-5a.936.936 0 0 0-.919.753l-.467 2.333a13.4 13.4 0 0 0-2.453 1.016l-1.98-1.319a.94.94 0 0 0-1.183.117l-3.535 3.535a.94.94 0 0 0-.117 1.183l1.319 1.98a13.4 13.4 0 0 0-1.016 2.453l-2.333.467a.94.94 0 0 0-.754.919v5c0 .447.316.832.754.919l2.333.467a13.4 13.4 0 0 0 1.016 2.453l-1.319 1.98a.94.94 0 0 0 .117 1.183l3.535 3.535a.94.94 0 0 0 1.183.117l1.939-1.292v-5.885a8.7 8.7 0 0 1-2.37-5.977 8.75 8.75 0 1 1 17.5 0 8.7 8.7 0 0 1-2.37 5.977v5.885l1.939 1.292a.94.94 0 0 0 1.183-.117l3.535-3.535a.94.94 0 0 0 .117-1.183l-1.319-1.98a13.4 13.4 0 0 0 1.016-2.453l2.333-.467a.94.94 0 0 0 .754-.919v-5a.94.94 0 0 0-.754-.919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.97 419.8a.77.77 0 0 0-1.148.557l-.572 3.955h-2.5l-.571-3.955a.77.77 0 0 0-1.149-.557 5.96 5.96 0 0 0-2.968 5.137 5.9 5.9 0 0 0 3.339 5.333l.099.049v9.743c0 .518.42.938.938.938h3.124c.518 0 .938-.42.938-.938v-9.743l.099-.049a5.9 5.9 0 0 0 3.339-5.333 5.96 5.96 0 0 0-2.968-5.137"
})))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#what_svg__I)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  x: 238,
  y: 433,
  fill: "#fff",
  fillOpacity: 0.1,
  rx: 32
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 63,
  x: 238.5,
  y: 433.5,
  stroke: "#fff",
  strokeOpacity: 0.3,
  rx: 31.5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#what_svg__J)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M271.687 458.94c-.561.015-1.034-.542-.924-1.096l.374-2.184-1.586-1.546a.94.94 0 0 1-.237-.961.94.94 0 0 1 .756-.638l2.193-.319.981-1.987a.938.938 0 0 1 1.681 0l.981 1.987 2.192.319a.94.94 0 0 1 .757.638.94.94 0 0 1-.237.961l-1.587 1.546.375 2.184a.938.938 0 0 1-1.361.989l-1.961-1.031-1.961 1.031a.94.94 0 0 1-.436.107M277.487 468.434c-.56.014-1.034-.542-.924-1.097l.469-2.735-1.987-1.938a.938.938 0 0 1 .519-1.599l2.747-.399 1.228-2.489a.937.937 0 0 1 1.682 0l1.228 2.489 2.747.399a.938.938 0 0 1 .52 1.599l-1.988 1.938.469 2.735a.937.937 0 0 1-1.36.989l-2.457-1.292-2.457 1.292a.94.94 0 0 1-.436.108M277.833 471.424a3.09 3.09 0 0 0-2.618-1.448l-2.431-.008.42-1.81a2.9 2.9 0 0 0-.385-2.239 2.82 2.82 0 0 0-2.714-1.303.63.63 0 0 0-.565.357l-1.358 2.868a4.74 4.74 0 0 1-1.616 1.888l-2.796 1.905v8.679h8.88c1.56 0 2.999-.911 3.666-2.321l1.697-3.581a3.09 3.09 0 0 0-.18-2.987M258.397 471.635a.625.625 0 0 0-.626.625v7.423c0 .345.28.625.626.625h3.497v-8.673zM262.841 460.69a4.188 4.188 0 1 0 .001-8.377 4.188 4.188 0 0 0-.001 8.377"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.841 462.565a6 6 0 0 1-2.669-.619 5.96 5.96 0 0 0-5.336 4.888l-.819 4.556a.937.937 0 0 0 .919 1.124h1.586v-1.817c0-.518.419-.938.937-.938h5.731l2.321-1.58c.42-.286.758-.681.976-1.141l1.358-2.868c.187-.395.473-.725.819-.969a5.96 5.96 0 0 0-3.156-1.255 6 6 0 0 1-2.667.619"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__a",
  width: 670,
  height: 670,
  x: 0,
  y: -0.001,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13188",
  stdDeviation: 100
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__f",
  width: 101,
  height: 108,
  x: 287,
  y: 163.883,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13188",
  stdDeviation: 20
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__h",
  width: 101,
  height: 108,
  x: 287,
  y: 222.883,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13188",
  stdDeviation: 20
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__i",
  width: 101,
  height: 108,
  x: 287,
  y: 281.883,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13188",
  stdDeviation: 20
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__j",
  width: 101,
  height: 108,
  x: 287,
  y: 340.883,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13188",
  stdDeviation: 20
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__k",
  width: 101,
  height: 108,
  x: 287,
  y: 399.883,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13188",
  stdDeviation: 20
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__l",
  width: 19.986,
  height: 25.365,
  x: 337.016,
  y: 212.518,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_20508_13188"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__o",
  width: 21.252,
  height: 25.805,
  x: 338.365,
  y: 267.518,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_20508_13188"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__r",
  width: 20.303,
  height: 25.365,
  x: 338.578,
  y: 322.518,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_20508_13188"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__u",
  width: 20.004,
  height: 25.365,
  x: 338.596,
  y: 377.518,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_20508_13188"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__x",
  width: 24.469,
  height: 26.244,
  x: 337.766,
  y: 432.079,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_20508_13188"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__A",
  width: 104,
  height: 104,
  x: 214,
  y: 157,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13188"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13188",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__C",
  width: 104,
  height: 104,
  x: 196,
  y: 283,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13188"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13188",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__E",
  width: 104,
  height: 104,
  x: 97,
  y: 203,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13188"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13188",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__G",
  width: 104,
  height: 104,
  x: 101,
  y: 373,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13188"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13188",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "what_svg__I",
  width: 104,
  height: 104,
  x: 218,
  y: 413,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13188"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13188",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__b",
  x1: 335,
  x2: 335,
  y1: 199.999,
  y2: 469.999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48C9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.475,
  stopColor: "#9D0FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.945,
  stopColor: "#FFA928"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__c",
  x1: 546.597,
  x2: 131.038,
  y1: 348.014,
  y2: 337.751,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A531DC",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.925,
  stopColor: "#A531DC",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__d",
  x1: 325.76,
  x2: 333.338,
  y1: 490.87,
  y2: 184.028,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A531DC",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.925,
  stopColor: "#A531DC",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__e",
  x1: 435.113,
  x2: 239.017,
  y1: 341.935,
  y2: 337.117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A531DC",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.925,
  stopColor: "#A531DC",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__g",
  x1: 10.5,
  x2: 10.5,
  y1: 0,
  y2: 28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D0FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.945,
  stopColor: "#FFA928"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__m",
  x1: 342.543,
  x2: 367.623,
  y1: 206.546,
  y2: 216.526,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__n",
  x1: 469.184,
  x2: 469.184,
  y1: 211.338,
  y2: 236.971,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__p",
  x1: 343.733,
  x2: 371.849,
  y1: 261.546,
  y2: 274.768,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__q",
  x1: 483.958,
  x2: 483.958,
  y1: 266.338,
  y2: 291.971,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__s",
  x1: 343.138,
  x2: 369.805,
  y1: 316.546,
  y2: 328.122,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__t",
  x1: 481.958,
  x2: 481.958,
  y1: 321.338,
  y2: 346.971,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__v",
  x1: 343.138,
  x2: 369.805,
  y1: 371.546,
  y2: 383.122,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__w",
  x1: 520.645,
  x2: 520.645,
  y1: 376.338,
  y2: 401.971,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__y",
  x1: 344.328,
  x2: 373.755,
  y1: 426.546,
  y2: 441.449,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "what_svg__z",
  x1: 510.443,
  x2: 510.443,
  y1: 431.338,
  y2: 456.971,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "what_svg__B"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M250 193h32v32h-32z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "what_svg__D"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M232 319h32v32h-32z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "what_svg__F"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M133 239h32v32h-32z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "what_svg__H"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M137 409h32v32h-32z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "what_svg__J"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M254 449h32v32h-32z"
})))));
export { SvgWhat as ReactComponent };
export default __webpack_public_path__ + "static/media/what.9e1cda83.svg";